/*eslint-disable*/
import { CheckBox } from 'components/CheckBox/CheckBox'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { ISelectValue } from 'constants/globalTypes'
import { dietaryPreferences } from 'pages/Food/foodData'
import React, { useState } from 'react'
import { Animation, Button, ButtonsContainer, Flex, StyledContainer, TabFooter } from 'styling/GlobalStyles'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { IEmployeesTabWithValidation } from 'types/users.interface'
import { logisticsTransportationTypes, transportationVehicleTypes } from './employeesData'
import { CancelBtn } from 'components/Button/CancelBtn'
import { toast } from 'react-toastify'
import { standardFieldValidation } from 'utils/validationUtils'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { WelfareConatainer } from './Employees.styled'

export const EmployeeWelfareTab = ({
    setActive,
    state,
    setState,
    invalidFields,
    setInvalidFields
}: IEmployeesTabWithValidation) => {
    const [selectedMealType, setSelectedMealType] = useState<ISelectValue>(null)

    const handleCheckbox = (name: string, fieldsToReset?: string[]) => {
        setInvalidFields(prev => {
            let copy = [...prev]
            if (state.logisticsInfo[name]) {
                if (name == 'hasFoodProvided') {
                    copy = copy.filter(f => f !== 'foodDietaryPreferenceType' && f !== 'mealTypes')
                }
                if (name == 'hasFoodAllowance') {
                    copy = copy.filter(f => f !== 'foodAllowanceInCompanyAmount' && f !== 'foodAllowanceOutCompanyAmount')
                }

                if (name == 'hasAccommodationAllowance') {
                    copy = copy.filter(f => f !== 'accomodationAllowanceInCompanyAmount' && f !== 'accomodationAllowanceOutCompanyAmount')
                }
                if (name == 'hasTransportationAllowance') {
                    copy = copy.filter(f => f !== 'transportationAllowanceInCompanyAmount' && f !== 'transportationAllowanceOutCompanyAmount')
                }
                if (name == 'hasResponsibilityAllowance') {
                    copy = copy.filter(f => f !== 'responsibilityAllowanceInCompanyAmount' && f !== 'responsibilityAllowanceOutCompanyAmount')
                }
                if (name == 'hasExtraDutyAllowance') {
                    copy = copy.filter(f => f !== 'extraDutyAllowanceInCompanyAmount' && f !== 'extraDutyAllowanceOutCompanyAmount')
                }
            } else {
                if (name == 'hasFoodProvided') {
                    copy = [...copy, 'foodDietaryPreferenceType']
                }
                if (name == 'hasFoodAllowance') {
                    copy = [...copy, 'foodAllowanceInCompanyAmount', 'foodAllowanceOutCompanyAmount']
                }

                if (name == 'hasAccommodationAllowance') {
                    copy = [...copy, 'accomodationAllowanceInCompanyAmount', 'accomodationAllowanceOutCompanyAmount']
                }
                if (name == 'hasTransportationAllowance') {
                    copy = [...copy, 'transportationAllowanceInCompanyAmount', 'transportationAllowanceOutCompanyAmount']
                }
                if (name == 'hasResponsibilityAllowance') {
                    copy = [...copy, 'responsibilityAllowanceInCompanyAmount', 'responsibilityAllowanceOutCompanyAmount']
                }
                if (name == 'hasExtraDutyAllowance') {
                    copy = [...copy, 'extraDutyAllowanceInCompanyAmount', 'extraDutyAllowanceOutCompanyAmount']
                }

            }
            return copy
        })

        setState(prev => {
            if (fieldsToReset) {
                let copy = { ...prev }
                fieldsToReset.forEach(f => {
                    copy.logisticsInfo[f] = null
                })
            }
            return { ...prev, logisticsInfo: { ...prev.logisticsInfo, [name]: !prev.logisticsInfo[name] } }

        })
    }

    const handleSelect = (v: ISelectValue, n: string) => {

        // TODO: Treba refactor ovoga, ovo je temp fix bio
        setInvalidFields(prev => {
            let copy = [...prev]

            if (n == 'accommodation') {
                if (v.value) {
                    copy = copy.filter(f => f !== 'accommodation')
                } else {
                    copy = [...copy, 'accommodation']
                }
            }

            if (n == 'foodDietaryPreferenceType') {
                if (v.value) {
                    copy = copy.filter(f => f !== 'foodDietaryPreferenceType')
                } else {
                    copy = [...copy, 'foodDietaryPreferenceType']
                }
            }

            if (n == 'transportationTransferPoint') {
                return copy
            }
            if (n == 'transportationType') {
                if (v.value == 2) {
                    copy = [...copy, 'transportationVehicleType']
                } else {
                    copy = copy.filter(f => f !== 'transportationVehicleType')

                }
            } else if (n == 'transportationVehicleType') {
                if (v.value) {
                    copy = copy.filter(f => f !== 'transportationVehicleType')
                } else {
                    copy = [...copy, 'transportationVehicleType']
                }
            }
            return copy
        })
        setState(prev => ({ ...prev, logisticsInfo: { ...prev.logisticsInfo, [n]: v } }))
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { valueAsNumber, name } = e.target
        standardFieldValidation(e, setInvalidFields, true)
        setState(prev => ({ ...prev, logisticsInfo: { ...prev.logisticsInfo, [name]: valueAsNumber } }))
    }

    const parse = (data: any) => {
        return data.data.map((item) => ({ label: item.name, value: item.id }))
    }

    const addMealType = () => {
        if (selectedMealType) {
            setState(prev => ({ ...prev, logisticsInfo: { ...prev.logisticsInfo, mealTypes: [...prev.logisticsInfo.mealTypes, selectedMealType] } }))
            setSelectedMealType(null)
        }

    }

    const removeType = (id: number) => {
        setState(prev => ({ ...prev, logisticsInfo: { ...prev.logisticsInfo, mealTypes: prev.logisticsInfo.mealTypes.filter(m => m.value !== id) } }))
    }

    const handleNext = () => {
        if (invalidFields.length) {

            toast.warn('Please fill all required fields')
        } else {
            setActive('Contract')
        }
    }


    return <Animation>
        <WelfareConatainer >
            <Flex padding='1rem' width='100%' container column gap='1rem'  >
                <TitleText weight='bold' >Food</TitleText>
                <CheckBox state={state?.logisticsInfo?.hasFoodProvided} onClick={() => handleCheckbox('hasFoodProvided',)} square title='Include Food' />
                <CheckBox state={state?.logisticsInfo?.hasFoodAllowance} onClick={() => handleCheckbox('hasFoodAllowance', ['foodAllowanceInCompanyAmount', 'foodAllowanceOutCompanyAmount'])} square title='Food Allowance' />
                {state?.logisticsInfo?.hasFoodAllowance && <>
                    <Input allowZero name='foodAllowanceInCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.foodAllowanceInCompanyAmount} labelText='Food Allowance (Internal)' placeholder='1500' nomarg invalid={invalidFields.includes('foodAllowanceInCompanyAmount')} />
                    <Input allowZero name='foodAllowanceOutCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.foodAllowanceOutCompanyAmount} labelText='Food Allowance (External)' placeholder='500' nomarg invalid={invalidFields.includes('foodAllowanceOutCompanyAmount')} />
                </>}
                {state?.logisticsInfo?.hasFoodProvided && <>
                    <HonestSelectInput options={dietaryPreferences} name='foodDietaryPreferenceType' defaultValue={state?.logisticsInfo?.foodDietaryPreferenceType?.value} labelText='Dietary Preference' onChange={handleSelect} nomarg invalid={invalidFields.includes('foodDietaryPreferenceType')} />
                    <HonestSelectAsyncInput
                        name='foodMealSupplier'
                        labelText='Meal Supplier'
                        onChange={handleSelect}
                        placeholder='Select Meal Supplier'
                        link='food/management/meal/supplier'
                        parserFunction={parse}
                        defaultValue={state.logisticsInfo.foodMealSupplier?.label || null}
                        invalid={invalidFields.includes('mealSupplier')}
                        nomarg
                    />
                    <Flex width='100%' gap='2rem' alignEnd >
                        <HonestSelectAsyncInput
                            name='mealTypes'
                            labelText='Meal Types'
                            onChange={v => setSelectedMealType(v)}
                            placeholder='Select Meal Type'
                            link='food/management/meal/type'
                            parserFunction={parse}
                            defaultValue={selectedMealType?.label}
                            invalid={invalidFields.includes('mealTypes')}
                            nomarg
                        />
                        <Button disabled={!selectedMealType?.value} orange onClick={addMealType}>
                            Add
                        </Button>
                    </Flex>
                    <Flex column gap='5px' >
                        <OtherText>Selected Meal Types:</OtherText>
                        {state?.logisticsInfo?.mealTypes.map(m => <StyledContainer style={{ padding: 5 }} height='auto' width='100%' >
                            <Flex between center >
                                <BodyText>{m.label}</BodyText>
                                <CloseIcon onClick={() => removeType(m.value)} />
                            </Flex>
                        </StyledContainer>
                        )}
                    </Flex>
                </>}
            </Flex>
            <Flex padding='1rem' width='100%' container column gap='1rem'  >
                <TitleText weight='bold' >Accommodation</TitleText>
                <CheckBox state={state?.logisticsInfo?.hasAccommodationProvided} onClick={() => handleCheckbox('hasAccommodationProvided')} square title='Include Accommodation' />
                {/* {state?.logisticsInfo?.hasAccommodationProvided && <HonestSelectAsyncInput
                    name='accommodation'
                    labelText='Accommodation provided'
                    onChange={handleSelect}
                    placeholder='Select Accomodation'
                    link='accommodation/management/accommodation'
                    parserFunction={parse}
                    defaultValue={state?.logisticsInfo?.accommodation?.label}
                    invalid={invalidFields.includes('accommodation')}
                    nomarg
                />} */}
                <CheckBox state={state?.logisticsInfo?.hasAccommodationAllowance} onClick={() => handleCheckbox('hasAccommodationAllowance', ['accomodationAllowanceInCompanyAmount', 'accomodationAllowanceOutCompanyAmount'])} square title='Accommodation Allowance' />
                {state?.logisticsInfo?.hasAccommodationAllowance && <>
                    <Input allowZero name='accomodationAllowanceInCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.accomodationAllowanceInCompanyAmount} labelText='Accommodation Allowance (Internal)' placeholder='1500' nomarg invalid={invalidFields.includes('accomodationAllowanceInCompanyAmount')} />
                    <Input allowZero name='accomodationAllowanceOutCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.accomodationAllowanceOutCompanyAmount} labelText='Accommodation Allowance (External)' placeholder='500' nomarg invalid={invalidFields.includes('accomodationAllowanceOutCompanyAmount')} />
                </>}
            </Flex>
            <Flex padding='1rem' width='100%' container column gap='1rem'  >
                <TitleText weight='bold' >Transportation</TitleText>
                <HonestSelectInput options={logisticsTransportationTypes} labelText='Transport Type' name='transportationType' defaultValue={state?.logisticsInfo?.transportationType?.value} onChange={handleSelect} nomarg invalid={invalidFields.includes('transportationType')} />
                {state?.logisticsInfo?.transportationType?.value == 2 && <HonestSelectInput
                    name='transportationVehicleType'
                    labelText='Vehicle Type'
                    onChange={handleSelect}
                    placeholder='Select Transportation Vehicle Type'
                    options={transportationVehicleTypes}
                    defaultValue={state?.logisticsInfo?.transportationVehicleType?.value}
                    nomarg
                    invalid={invalidFields.includes('transportationVehicleType')}
                />}
                {state?.logisticsInfo?.transportationType?.value == 2 && <HonestSelectAsyncInput
                    name='transportationTransferPoint'
                    labelText='Transportation Point'
                    onChange={handleSelect}
                    placeholder='Select Transportation Point'
                    link='transportation/management/transfer-point'
                    parserFunction={parse}
                    defaultValue={state?.logisticsInfo?.transportationTransferPoint?.label}
                    nomarg
                />}
                <CheckBox state={state?.logisticsInfo?.hasTransportationAllowance} onClick={() => handleCheckbox('hasTransportationAllowance', ['transportationAllowanceInCompanyAmount', 'transportationAllowanceOutCompanyAmount'])} square title='Transport Allowance' />
                {state?.logisticsInfo?.hasTransportationAllowance && <>
                    <Input allowZero name='transportationAllowanceInCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.transportationAllowanceInCompanyAmount} labelText='Transport Allowance (Internal)' placeholder='1500' nomarg invalid={invalidFields.includes('transportationAllowanceInCompanyAmount')} />
                    <Input allowZero name='transportationAllowanceOutCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.transportationAllowanceOutCompanyAmount} labelText='Transport Allowance (External)' placeholder='500' nomarg invalid={invalidFields.includes('transportationAllowanceOutCompanyAmount')} />
                </>}
            </Flex>
            <Flex padding='1rem' width='100%' container column gap='1rem'  >
                <TitleText weight='bold' >Responsibility and Extra Duty Allowance</TitleText>
                <CheckBox state={state?.logisticsInfo?.hasResponsibilityAllowance} onClick={() => handleCheckbox('hasResponsibilityAllowance', ['responsibilityAllowanceInCompanyAmount', 'responsibilityAllowanceOutCompanyAmount'])} square title='Include Responsibility Allowance' />
                {state?.logisticsInfo?.hasResponsibilityAllowance && <>
                    <Input allowZero name='responsibilityAllowanceInCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.responsibilityAllowanceInCompanyAmount} labelText='Responsibility Allowance (Internal)' placeholder='1500' nomarg invalid={invalidFields.includes('responsibilityAllowanceInCompanyAmount')} />
                    <Input allowZero name='responsibilityAllowanceOutCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.responsibilityAllowanceOutCompanyAmount} labelText='Responsibility Allowance (External)' placeholder='500' nomarg invalid={invalidFields.includes('responsibilityAllowanceOutCompanyAmount')} />
                </>}
                <CheckBox state={state?.logisticsInfo?.hasExtraDutyAllowance} onClick={() => handleCheckbox('hasExtraDutyAllowance', ['extraDutyAllowanceInCompanyAmount', 'extraDutyAllowanceOutCompanyAmount'])} square title='Include Extra Duty Allowance' />
                {state?.logisticsInfo?.hasExtraDutyAllowance && <>
                    <Input allowZero name='extraDutyAllowanceInCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.extraDutyAllowanceInCompanyAmount} labelText='Extra Duty Allowance (Internal)' placeholder='1500' nomarg invalid={invalidFields.includes('extraDutyAllowanceInCompanyAmount')} />
                    <Input allowZero name='extraDutyAllowanceOutCompanyAmount' onChange={handleChange} type='number' value={state?.logisticsInfo?.extraDutyAllowanceOutCompanyAmount} labelText='Extra Duty Allowance (External)' placeholder='500' nomarg invalid={invalidFields.includes('extraDutyAllowanceOutCompanyAmount')} />
                </>}
            </Flex>

        </WelfareConatainer>
        <TabFooter  >
            <ButtonsContainer>
                <CancelBtn />
                <Button orange onClick={handleNext}>
                    Next
                </Button>
            </ButtonsContainer>
        </TabFooter>
    </Animation>
}